import { BASE_GEO_API_URL, BO_API_URL, BOND_API_KEY } from "../config";
import defaultAxios from "axios";

const locationAxios = defaultAxios.create({
  headers: {}
});

export async function fetchAvailableCities() {
  return locationAxios.get(
    `${BO_API_URL}/api/v2/integration/available-cities`
  );
}

export async function fetchAvailableTimeSlots(store_id, city, isTimeSlot = true) {
  return locationAxios.get(
    `${BO_API_URL}/api/v2/integration/available-dates-by-store/${store_id}?city=${city}&isTimeSlot=${isTimeSlot}`
  );
}